import { DataCapsule, LocalStorageStrategy } from 'data-capsule';

const APP_DEF_ID = '150ae7ee-c74a-eecd-d3d7-2112895b988a';
const DISMISSED_COOKIES_BANNER = 'dismissed-cookies-banner';
const TWO_WEEKS_IN_SECONDS = 1209600;

const capsule = new DataCapsule({
  strategy: new LocalStorageStrategy(),
  namespace: APP_DEF_ID,
});

export async function isCookiesBannerDismissed() {
  return capsule.getItem(DISMISSED_COOKIES_BANNER).catch(() => {});
}

export async function dismissCookiesBanner() {
  return capsule
    .setItem(DISMISSED_COOKIES_BANNER, true, {
      expiration: TWO_WEEKS_IN_SECONDS,
    })
    .catch(() => {});
}

export async function removeCookiesBannerDismissed() {
  return capsule.removeItem(DISMISSED_COOKIES_BANNER).catch(() => {});
}
